import { Form, FormFieldType } from "@/forms/Form";

export class WorkOrderDefectsDataForm extends Form {
  public definition = {
    defects: { required: true, type: FormFieldType.Text }
  };
}
